import { NgComponentOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NotificationMasterService } from 'src/app/pages/notification-master/service/notification-master.service';
import { AlertService } from 'src/app/core/service/alert.service';
import { Router } from '@angular/router';
import { NotificationViewModalComponent } from 'src/app/shared/notification-detail-content/notification-view-modal.component';
export interface Notification {
    id: number;
    title: string;
    alert_type: string;
    message: string;
    meta?: any; // e.g., Requested: Name or Expected by: Date
    meta_data?: any; // Alternative property name
    amount?: string; // optional currency text
    read: boolean;
    iconCmp: any; // Component class to render as icon
    time?: string;
    created_at?: string;
    action?: any;
}
@Component({
    selector: 'app-notification',
    imports: [CommonModule, NgComponentOutlet, SharedModule, NotificationViewModalComponent],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.css',
})
export class NotificationComponent {
    @Input() notifications: Array<Notification> = [];
    @Input() filteredNotifications: Array<Notification> = [];
    @Output() fetchNotifications = new EventEmitter<void>();
    @Output() closeNotificationPopup = new EventEmitter<void>();

    private normalizeReadFlag(value: unknown): boolean {
        if (value === true || value === 1) return true;
        if (value === false || value === 0 || value == null) return false;
        if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'true' || v === '1') return true;
            if (v === 'false' || v === '0' || v === '') return false;
        }
        return Boolean(value);
    }
    viewNotificationModel = signal<boolean>(false);
    isReadableNotificationDetails = signal<any>({});
    constructor(
        private readonly notificationMasterService: NotificationMasterService,
        private readonly alertService: AlertService,
        private readonly router: Router
    ) {}
    formatTitle(type: string): string {
        if (type) {
            return type
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        }
        return '-';
    }

    timeAgo(date: string): string {
        if (date) {
            const time = new Date(date).getTime();
            const now = new Date().getTime();
            const diff = Math.floor((now - time) / 1000);

            if (diff < 60) return 'Just now';
            if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
            if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
            return `${Math.floor(diff / 86400)} day(s) ago`;
        }
        return '-';
    }

    handleNotificationClick(notification: Notification) {
        this.fetchByIdNotification(notification.id);
    }

    fetchByIdNotification(id: number) {
        this.viewNotificationModel.set(true);
        this.notificationMasterService.fetchByIdNotification(id).subscribe({
            next: (res) => {
                if (res.status) {
                    this.filteredNotifications = this.filteredNotifications.map((notification) => {
                        if (notification.id === id) {
                            notification.read = this.normalizeReadFlag(res?.data?.is_read);
                        }
                        return notification;
                    });

                    this.isReadableNotificationDetails.set(res.data);
                    this.fetchNotifications.emit();
                }
            },
            error: (error) => {
                this.alertService.showAlert('Error', error?.error?.message || error?.error?.error, 'error');
            },
        });
    }

    closeViewNotificationModal() {
        this.viewNotificationModel.set(false);
    }

    getTimeAgo(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diffInMs = now.getTime() - date.getTime();
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInHours < 1) {
            const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
            return `${diffInMinutes} min ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours} hr ago`;
        } else {
            return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
        }
    }

    formatDate(date: string) {
        if (!date) return '';
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    navigateToNotificationList() {
        this.closeNotificationPopup.emit();
        this.router.navigate(['/notification-master/notification']);
    }
}
